import { create } from 'zustand';

interface LayoutState {
  isNavbarVisible: boolean;
  setNavbarVisibility: (isVisible: boolean) => void;
  isFocused: boolean;
  setIsFocused: (isFocused: boolean) => void;
  islayout: boolean;
  setIsLayout: (islayout: boolean) => void;
  isAppLoading: boolean;
  setAppLoading: (isLoading: boolean) => void;
  hide: boolean;
  setHide: (hide: boolean) => void;
}

const useLayoutStore = create<LayoutState>((set) => ({
  isNavbarVisible: true, // The navbar is visible by default on all pages
  setNavbarVisibility: (isVisible) => set({ isNavbarVisible: isVisible }),
  isFocused: false,
  setIsFocused: (isFocused) => set({ isFocused }),
  islayout: true,
  setIsLayout: (islayout) => set({ islayout }),
  isAppLoading: true, // Start as true on initial app load
  setAppLoading: (isLoading) => set({ isAppLoading: isLoading }),
  hide: false,
  setHide: (hide) => set({ hide }),
}));

export default useLayoutStore;
